@let contact = item.contactId ? (item.contactId | contactById | async) : undefined;
<div class="call-history-text">
  @if (contact) {
    <div
      class="name ellipsis"
      id="name">
      {{ contact.fullName | phoneNumber }}
    </div>
  } @else {
    <div
      data-id="name"
      class="name ellipsis"
      id="name">
      @if (item.direction === CallDirection.incoming) {
        {{ item | incomingCallerDescription }}
      } @else {
        {{ item.toLabel | phoneNumber }}
      }
    </div>
  }
  @if (contact && contact.company) {
    <div class="meta-text company ellipsis">{{ contact.company }}</div>
  }
  <div class="meta-text call-number">
    {{ (item.direction === CallDirection.incoming ? item.fromNumber : item.toNumber) | phoneNumber }}
  </div>

  <div
    class="meta-text flex align-items-center"
    data-id="icon"
    [class.missed]="item.missed">
    @if (item.missed) {
      <mat-icon>call_missed</mat-icon>
    } @else if (item.direction === CallDirection.incoming) {
      <mat-icon>call_received</mat-icon>
    } @else if (item.direction === CallDirection.outgoing) {
      <mat-icon>call_made</mat-icon>
    }
    <span
      id="time"
      data-id="time"
      class="ellipsis">
      {{ item.dateTime | timestamp: 'short' }}
      @if (item.direction === CallDirection.incoming && item.cancelReason) {
        @if (item.cancelReason === CallMissedReason.CompletedElsewhere && item.termToUri) {
          <span class="value push">{{ ('CALLS.ANSWERED_BY_TEXT' | translate) + (item.termToUri | sipUriNumber) }}</span>
        } @else if (item.queueDescription && item.cancelReason !== CallMissedReason.CompletedElsewhere) {
          <span class="value push">
            {{ item.queueDescription }}
          </span>
        }
      }
    </span>
  </div>
</div>
